import { getInLifeQuotingFieldsData } from '@in-life/utils/getInLifeQuotingFieldsData';
import { useTrackPage } from '@utilitywarehouse/tracking-react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { stripTrailingSlash } from '@utils/routing/stripTrailingSlash';

const useInLifePageTracking = () => {
  const { pathname } = useLocation();
  const trackPage = useTrackPage();

  useEffect(() => {
    trackPage(stripTrailingSlash(pathname), undefined, {
      contexts: [getInLifeQuotingFieldsData()],
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
};

export { useInLifePageTracking };
